var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column min-vh-100"},[_c('Header'),_vm._v(" "),_c('Nuxt',{staticClass:"flex-1"}),_vm._v(" "),_c('Footer'),_vm._v(" "),_c('compare-lenders-popup')],1)}
var staticRenderFns = []

export { render, staticRenderFns }